import { SnowboardSize } from '../types/snowboard'
import '../styles/SizeSelector.css'

interface SizeSelectorProps {
  sizes: SnowboardSize[]
  selectedSize: string | null
  onSelect: (size: string) => void
}

export function SizeSelector({ sizes, selectedSize, onSelect }: SizeSelectorProps) {
  return (
    <div className="size-selector">
      <div className="size-grid">
        {sizes.map(({ size, available }) => (
          <button
            key={size}
            className={`size-button ${selectedSize === size ? 'selected' : ''}`}
            disabled={!available}
            onClick={() => onSelect(size)}
          >
            {size}
          </button>
        ))}
      </div>
    </div>
  )
}